import styled, { css, keyframes } from "styled-components"
import { BasicItem, ItemImage, ItemText } from "../../list/list-item.component"
import { Link } from "gatsby"
import { SectionContainer } from "../../../../../resolvers/text/text.resolver"
import {
  FiveColumnsList,
  FourColumnsList,
  ThreeColumnsList,
} from "../../list/list.component"
import { BackgroundWrapper, SectionArticle } from "../../section.component"
import { PrimaryHeading } from "../../../heading.component"
import { ListBuilder, ListBuilderWithHash } from "../../../../../types"

export const slideIn = keyframes`
  from {
    transform: translateY(-10%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

export const slideOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(10%);
    opacity: 0;
  }
`

export const slideInOpacity = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const slideOutOpacity = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

export const QuickStartSectionWrapper = styled.section<{
  revealedSectionId: string | null
}>`
  grid-row-gap: var(--grid-spacing);
  display: grid;
  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    display: grid;
    transform: translateY(0);
    animation: ${({ id, revealedSectionId }) =>
        id === revealedSectionId ? slideIn : slideOut}
      0.5s ease-in-out;
  }
`

export const QuickStartListContainerInsideThreeColumn = styled(
  ThreeColumnsList
)`
  margin-top: 0;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    grid-column-gap: 70px;
  }
`

export const QuickStartListContainerInsideFourColumn = styled(FourColumnsList)`
  margin-top: 0;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    grid-column-gap: 70px;
  }
`

export const QuickStartListContainerInsideFiveColumn = styled(FiveColumnsList)`
  margin-top: 0;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    grid-column-gap: 70px;
  }
`

export const QuickStartListContainer = styled(BackgroundWrapper)<{
  style?: ListBuilderWithHash["style"]
}>`
  padding-top: 0;
  padding-bottom: 0;
  ${({ style }) =>
    style?.color &&
    css`
      h3,
      p,
      a {
        color: ${style.color};
      }
    `}
`

export const QuickStartMainTextContainer = styled(SectionContainer)`
  grid-template-areas:
    "Article Article"
    "SecondArticle SecondArticle";
  grid-column-gap: 0px;
  article {
    padding-bottom: 0;
    align-self: flex-start;

    h1 {
      margin-top: unset;
      text-align: left;
      margin-bottom: unset;
      text-wrap: wrap;
    }

    p {
      text-align: left;
      margin-bottom: unset;
      text-wrap: wrap;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    grid-row-gap: 5px;
    grid-template-rows: 1fr 1fr;
    grid-column-gap: 120px;
    article {
      h1 {
        text-align: center;
      }

      p {
        text-align: center;
      }
    }
  }
`

export const QuickStartBreathingEmbedContainer = styled.div`
  display: grid;
  grid-column-gap: 60px;
  align-items: center;
  width: calc(100% - 60px);
  --max-width: 1160;
  max-width: calc(var(--max-width) * 1px);
  margin: auto;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    grid-template-columns: 1fr 1fr;
  }
`

export const QuickStartTextWithPhoto = styled.div`
  section {
    div {
      display: flex;
      flex-direction: column;
      width: 100% !important;
      gap: 1rem;
      article {
        padding-right: 0 !important;
        padding-top: 0 !important;
      }
    }
  }
`
export const QuickStartTextContainer = styled.div`
  h3 {
    margin: 0;
    font-size: 16px;
    display: inline;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }
  p,
  li {
    font-size: 14px;
  }
  li p {
    font-weight: 500;
  }
`
export const TextFlexTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 1rem 0;
`

export const TextWithEmbedStyle = styled.div`
  section {
    div {
      grid-template-areas:
        "Heading"
        "Article"
        "Image"
        "ImageDescription";

      @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
        grid-template-areas:
          "Heading Heading"
          "Article Image"
          "span ImageDescription";
      }
    }
  }
`

export const DownloadableRowStyle = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid #d8d8d8;

  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    justify-content: none;
  }

  .heading {
    padding: 16px 0px;
    font-family: Facto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
      padding: 16px 24px;
    }
  }

  p {
    margin-top: 0;
    padding: 28px 0px;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
      display: block;
      padding: 28px 24px;
    }
  }

  .bolded {
    font-weight: 600;
  }

  .first {
    flex-basis: 50%;
  }
  .second,
  .third {
    flex-basis: 18%;
    display: none;
    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
      display: block;
    }
  }

  .fourth {
    flex-basis: 12%;
    a {
      color: black;
      font-weight: 600;
    }

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
      flex-basis: 8%;
      display: block;
    }
  }
`

export const DownloadTableContainer = styled.div`
  width: calc(100% - 60px);
  --max-width: 1160;
  max-width: calc(var(--max-width) * 1px);
  margin: auto;
`

export const BorderLineStyle = styled.div`
  width: 100%;
  height: 2px;
  background: #d8d8d8;
  margin: 45px 0;
`

export const StyledEnrollLink = styled(Link)<{
  activeHashName: string | null | undefined
}>`
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  color: black;
  text-decoration: none;
  display: ${({ to, activeHashName }) =>
    activeHashName === to ? "none" : "flex"};
  align-items: center;
  position: absolute;
  bottom: -10%;
  left: 0;
`

export const StyledCard = styled.div<{
  activeHashName: string | boolean | null | undefined
  grayscale?: boolean
  index: number
  currentIndex: number
  customStyle?: ListBuilder["style"]
}>`
  position: relative;

  animation: ${({ index, currentIndex }) =>
    index === currentIndex ? slideInOpacity : slideOutOpacity}
    0.5s ease-in-out;

  display: ${({ currentIndex, index }) =>
    index === currentIndex ? "block" : "none"};

  ${ItemImage} {
    border-radius: 16px;
    max-width: unset;
    max-height: 300px;
  }
  img {
    object-fit: contain;
  }

  ${BasicItem}{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }

  ${({ customStyle }) =>
    customStyle?.text_align &&
    css`
      ${ItemText} {
        text-align: ${customStyle.text_align ?? "unset"};
      }
    `}

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    /* height: 460px; */
    display: block;
    transform: unset;
    animation: unset;
    ${ItemImage} {
      height: 210px;
    }
    ${({ index, grayscale, currentIndex }) =>
      grayscale &&
      css`
        img {
          filter: ${index === currentIndex ? "grayscale(0)" : "grayscale(1)"};
        }
      `}
`

export const QuickStartArticle = styled(SectionArticle)`
  align-self: flex-start;
  ${PrimaryHeading}:first-child {
    margin-top: unset;
    margin-bottom: unset;
  }

  p {
    margin-bottom: unset !important;
  }
`

export const SliderButtonStyle = styled.button<{
  disabledNext?: boolean
  disabledPrev?: boolean
  color?: string
}>`
  display: flex;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  border: 2px solid ${({ color }) => color ?? "#000"};
  font-family: Facto;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-transform: uppercase;
  background: transparent;
  color: ${({ color }) => color ?? "#000"};
  transition: opacity 0.3s ease-in-out;

  svg {
    path {
      fill: ${({ color }) => color ?? "#000"};
    }
  }

  ${({ disabledPrev, disabledNext }) =>
    (disabledPrev || disabledNext) &&
    css`
      border: 2px solid #494949;
      color: #494949;
      opacity: 0;
      svg {
        path {
          fill: #494949;
        }
      }
    `}
`

export const StyledControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  margin-top: 20px;

  @media (min-width: 768px) {
    display: none;
    padding-left: 50px;
    padding-right: 50px;
  }
  @media (min-width: 1260px) {
    padding-left: calc((100% - 1160px) / 2);
    padding-right: calc((100% - 1160px) / 2);
  }
`
export const StyledDesktopListItem = styled.div`
  h2 {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 1rem;
    margin-top: 3rem;
    text-align: center;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
      font-size: 36px;
      font-weight: 500;
    }
  }
  p {
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
    text-align: center;
  }
`
